class TDMarquee extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.td-track');
    this.trackWidth = this.track.offsetWidth;
    this.trackCount = 1;

    this.duplicateTrackIfNeeded();

    window.addEventListener('resize', () => this.duplicateTrackIfNeeded());
  }

  duplicateTrackIfNeeded() {
    const originalTrackWidth = this.track.offsetWidth;

    while (this.trackWidth < window.innerWidth * 10) {
      const newTrack = this.track.cloneNode(true);
      newTrack.setAttribute('aria-hidden', 'true');
      this.track.parentNode.appendChild(newTrack);
      this.trackWidth += originalTrackWidth;
      this.trackCount++;
    }

    this.style.setProperty('--track-count', this.trackCount);
  }
}

customElements.define('td-marquee', TDMarquee);